export default {
  title: {
    notes: 'Title of the wear data panel shown below a deck layout',
    message: 'Wear data',
  },
  modes: {
    rate: {
      notes:
        'Wear data mode showing how fast the working depth of each position wears down',
      message: 'Wear rate',
    },
    replacement: {
      notes:
        'Wear data mode showing how many times each position was replaced in the period',
      message: 'Replacements',
    },
    depth: {
      notes:
        'Wear data mode showing the last measured remaining working depth of each position',
      message: 'Working depth',
    },
    aperture: {
      notes:
        'Wear data mode showing the last measured aperture width of each position',
      message: 'Aperture width',
    },
  },
  units: {
    label: {
      notes: 'Label of the wear rate unit toggle in the wear data panel',
      message: 'Units',
    },
    mmPerWeek: {
      notes: 'Wear rate unit: millimetres per week (abbreviated)',
      message: 'mm/wk',
    },
    mmPerMegatonne: {
      notes:
        'Wear rate unit: millimetres per megatonne of processed material (abbreviated)',
      message: 'mm/Mt',
    },
    mm: {
      notes:
        'Measurement unit toggle in the wear data panel: values in millimetres',
      message: 'mm',
    },
    percent: {
      notes:
        'Measurement unit toggle in the wear data panel: values as percent of the nominal value of the screening media',
      message: '%',
    },
  },
  materialFlow: {
    label: {
      notes:
        'Label of the input for how much material the screen processes per week, used to show wear rates per megatonne',
      message: 'Material flow / week',
    },
    unit: {
      notes: 'Unit of the material flow input: megatonnes per week',
      message: 'Mt/wk',
    },
  },
  allMaterials: {
    notes:
      'Material filter option in the wear data panel showing the wear rate over all screening media',
    message: 'All materials',
  },
  grids: {
    configuration: {
      notes:
        'Title of the wear grid projecting the replacement counts after installing the configuration being edited',
      message: 'Projected after configuration updates',
    },
    maintenance: {
      notes:
        'Title of the wear grid projecting the replacement counts after the planned maintenance activity is performed',
      message: 'Projected after maintenance activity',
    },
  },
  noData: {
    notes:
      'Shown in the wear data panel when the deck has no wear statistics in the selected period',
    message: 'No wear data recorded in the selected period.',
  },
};
